/** attrs: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "savedX": "Saved “{name}”",
  "createdPlayer": "Created “{name}”. Set it on each player",
  "createdContent": "Created “{name}”. Set it on each content item",
  "deleteQ": "Delete “{name}”? This can’t be undone.",
  "deleteUsedPlayerQ": "Delete “{name}”? Its value is removed from {n} player. This can’t be undone. | Delete “{name}”? Its value is removed from {n} players. This can’t be undone.",
  "deleteUsedContentQ": "Delete “{name}”? Its value is removed from {n} content item. This can’t be undone. | Delete “{name}”? Its value is removed from {n} content items. This can’t be undone.",
  "deletedX": "Deleted “{name}”",
  "groupX": "Group: {name}",
  "nPlayers": "{n} player | {n} players",
  "nItems": "{n} item | {n} items",
  "noPlayerAttrs": "No player attributes yet",
  "noContentAttrs": "No content attributes yet",
  "newPlayerAttr": "New player attribute",
  "newContentAttr": "New content attribute",
  "editX": "Edit · {name}",
  "shownPlayer": "Shown on each player, and as the column name in lists and reports.",
  "shownContent": "Shown on each content item, and as the column name in lists and reports.",
  "typeHintLocked": "{hint} The type and “For” can’t be changed later.",
  "type_text": "Text",
  "type_text_list": "Text list",
  "type_number": "Number",
  "type_number_list": "Number list",
  "hintText": "One value, e.g. a store code.",
  "hintTextList": "Several values, e.g. the brands shown.",
  "hintNumber": "One number, e.g. the floor.",
  "hintNumberList": "Several numbers, e.g. zone numbers.",
  "checkForm": "Check the form",
  "numbersOnly": "Suggested values of a number attribute must be numbers",
  "attrName": "Attribute name",
  "title": "Custom Attributes",
  "intro": "Add your own fields to players and content, like a store code, region or client. They show on each player and content item, can be columns in the Players list, and appear in reports.",
  "newAttr": "New Attribute",
  "attrsFor": "Attributes for",
  "players": "Players",
  "content": "Content",
  "colAttr": "Attribute",
  "colType": "Type",
  "colShown": "Shown",
  "colSetOn": "Set on",
  "actions": "Actions",
  "required": "Required",
  "playersList": "Players list",
  "reports": "Reports",
  "edit": "Edit",
  "delete": "Delete",
  "loading": "Loading…",
  "exPlayer": "For example Store ID, Region code or Screen model. Required ones must be filled when a player is added.",
  "exContent": "For example Client, Campaign code or Approved by.",
  "for": "For",
  "name": "Name",
  "namePh": "Store ID",
  "typeLocked": "The type can’t change once values exist. Create a new attribute instead.",
  "optional": "(optional)",
  "group": "Group",
  "groupPh": "Location",
  "groupHint": "Attributes in the same group are shown together.",
  "helpText": "Help text",
  "helpPh": "The code on the store’s sign, e.g. RUH-01",
  "suggested": "Suggested values",
  "commas": "(optional, separated by commas)",
  "reqPlayer": "Must be filled when a player is added, and can’t be left empty afterwards.",
  "reqContent": "Can’t be left empty when the item’s attributes are saved.",
  "showInList": "Show in the Players list",
  "showInListHint": "Adds a column; the list search also finds these values.",
  "showInReports": "Show in reports",
  "reportsPlayer": "Players and Published content reports.",
  "reportsContent": "The Published content report.",
  "preview": "Preview",
  "cancel": "Cancel",
  "create": "Create",
  "save": "Save",
  "saving": "Saving…"
};
const ar: typeof en = {
  "savedX": "تم حفظ «{name}»",
  "createdPlayer": "تم إنشاء «{name}». اضبطها على كل مشغل",
  "createdContent": "تم إنشاء «{name}». اضبطها على كل عنصر محتوى",
  "deleteQ": "حذف «{name}»؟ لا يمكن التراجع عن ذلك.",
  "deleteUsedPlayerQ": "حذف «{name}»؟ لا يمكن التراجع عن ذلك. | حذف «{name}»؟ ستُزال قيمتها من مشغل واحد. لا يمكن التراجع عن ذلك. | حذف «{name}»؟ ستُزال قيمتها من مشغلين. لا يمكن التراجع عن ذلك. | حذف «{name}»؟ ستُزال قيمتها من {n} مشغلات. لا يمكن التراجع عن ذلك. | حذف «{name}»؟ ستُزال قيمتها من {n} مشغلًا. لا يمكن التراجع عن ذلك. | حذف «{name}»؟ ستُزال قيمتها من {n} مشغل. لا يمكن التراجع عن ذلك.",
  "deleteUsedContentQ": "حذف «{name}»؟ لا يمكن التراجع عن ذلك. | حذف «{name}»؟ ستُزال قيمتها من عنصر محتوى واحد. لا يمكن التراجع عن ذلك. | حذف «{name}»؟ ستُزال قيمتها من عنصرَي محتوى. لا يمكن التراجع عن ذلك. | حذف «{name}»؟ ستُزال قيمتها من {n} عناصر محتوى. لا يمكن التراجع عن ذلك. | حذف «{name}»؟ ستُزال قيمتها من {n} عنصر محتوى. لا يمكن التراجع عن ذلك. | حذف «{name}»؟ ستُزال قيمتها من {n} عنصر محتوى. لا يمكن التراجع عن ذلك.",
  "deletedX": "تم حذف «{name}»",
  "groupX": "المجموعة: {name}",
  "nPlayers": "لا مشغلات | مشغل واحد | مشغلان | {n} مشغلات | {n} مشغلًا | {n} مشغل",
  "nItems": "لا عناصر | عنصر واحد | عنصران | {n} عناصر | {n} عنصرًا | {n} عنصر",
  "noPlayerAttrs": "لا توجد سمات مشغلات بعد",
  "noContentAttrs": "لا توجد سمات محتوى بعد",
  "newPlayerAttr": "سمة مشغل جديدة",
  "newContentAttr": "سمة محتوى جديدة",
  "editX": "تعديل · {name}",
  "shownPlayer": "تظهر على كل مشغل، وكاسم عمود في القوائم والتقارير.",
  "shownContent": "تظهر على كل عنصر محتوى، وكاسم عمود في القوائم والتقارير.",
  "typeHintLocked": "{hint} لا يمكن تغيير النوع و«لـ» لاحقًا.",
  "type_text": "نص",
  "type_text_list": "قائمة نصوص",
  "type_number": "رقم",
  "type_number_list": "قائمة أرقام",
  "hintText": "قيمة واحدة، مثل رمز المتجر.",
  "hintTextList": "عدة قيم، مثل العلامات التجارية المعروضة.",
  "hintNumber": "رقم واحد، مثل الطابق.",
  "hintNumberList": "عدة أرقام، مثل أرقام المناطق.",
  "checkForm": "تحقق من النموذج",
  "numbersOnly": "يجب أن تكون القيم المقترحة لسمة رقمية أرقامًا",
  "attrName": "اسم السمة",
  "title": "السمات المخصصة",
  "intro": "أضف حقولك الخاصة إلى المشغلات والمحتوى، مثل رمز المتجر أو المنطقة أو العميل. تظهر على كل مشغل وعنصر محتوى، ويمكن أن تكون أعمدة في قائمة المشغلات، وتظهر في التقارير.",
  "newAttr": "سمة جديدة",
  "attrsFor": "السمات لـ",
  "players": "المشغلات",
  "content": "المحتوى",
  "colAttr": "السمة",
  "colType": "النوع",
  "colShown": "تظهر في",
  "colSetOn": "مضبوطة على",
  "actions": "الإجراءات",
  "required": "مطلوبة",
  "playersList": "قائمة المشغلات",
  "reports": "التقارير",
  "edit": "تعديل",
  "delete": "حذف",
  "loading": "جارٍ التحميل…",
  "exPlayer": "مثل: معرّف المتجر أو رمز المنطقة أو طراز الشاشة. يجب ملء المطلوبة منها عند إضافة مشغل.",
  "exContent": "مثل: العميل أو رمز الحملة أو المعتمِد.",
  "for": "لـ",
  "name": "الاسم",
  "namePh": "معرّف المتجر",
  "typeLocked": "لا يمكن تغيير النوع بعد وجود قيم. أنشئ سمة جديدة بدلًا من ذلك.",
  "optional": "(اختياري)",
  "group": "المجموعة",
  "groupPh": "الموقع",
  "groupHint": "تُعرض السمات في المجموعة نفسها معًا.",
  "helpText": "نص المساعدة",
  "helpPh": "الرمز على لافتة المتجر، مثل RUH-01",
  "suggested": "القيم المقترحة",
  "commas": "(اختياري، مفصولة بفواصل)",
  "reqPlayer": "يجب ملؤها عند إضافة مشغل، ولا يمكن تركها فارغة بعد ذلك.",
  "reqContent": "لا يمكن تركها فارغة عند حفظ سمات العنصر.",
  "showInList": "إظهار في قائمة المشغلات",
  "showInListHint": "يضيف عمودًا؛ ويجد بحث القائمة هذه القيم أيضًا.",
  "showInReports": "إظهار في التقارير",
  "reportsPlayer": "تقارير المشغلات والمحتوى المنشور.",
  "reportsContent": "تقرير المحتوى المنشور.",
  "preview": "معاينة",
  "cancel": "إلغاء",
  "create": "إنشاء",
  "save": "حفظ",
  "saving": "جارٍ الحفظ…"
};
export default { en, ar };
